import { forwardRef } from "react";
import { TvIcon } from "./icons/TvIcon";
import "./ExistingUser.css";

interface ExistingUserProps {
  onManage: () => void;
  manageButtonRef?: React.Ref<HTMLButtonElement>;
}

export const ExistingUser = forwardRef<HTMLElement, ExistingUserProps>(
  function ExistingUser({ onManage, manageButtonRef }, ref) {
    return (
      <section
        className="account-row"
        aria-labelledby="existing-user-title"
        ref={ref}
      >
        <div className="existing-user">
          <span className="existing-user__icon" aria-hidden="true">
            <TvIcon size={120} />
          </span>
          <div className="existing-user__copy">
            <h2 id="existing-user-title" className="existing-user__title">
              EXISTING USER?
            </h2>
            <p className="existing-user__line">Manage your subscription.</p>
          </div>
        </div>

        <div className="account-action">
          <button
            ref={manageButtonRef}
            id="manageSubscriptionButton"
            type="button"
            className="account-button account-button--manage"
            onClick={onManage}
            aria-label="Manage existing subscription"
          >
            MANAGE SUBSCRIPTION
          </button>
          <span
            className="account-action__code account-action__code--manage"
            aria-hidden="true"
          >
            200
          </span>
        </div>
      </section>
    );
  },
);
